<template>
  <div style="margin:2% 4.5% 2% 4.5%">
    <vs-row>
      <vs-col v-if="cliente" vs-lg="8" vs-md="8" vs-sm="12" class="mb-5">
        <h1>{{cliente.nome}}</h1>
        <h3>{{cliente.cpf}}</h3>
      </vs-col>
      <vs-col vs-lg="4" vs-md="4" vs-sm="4" class="vx-col mb-2">
        <vs-button color="grey" @click="voltarHome()" type="relief" size="small" class="font-bold">
          <feather-icon class="align-middle mr-2" icon="CloseIcon" />Fechar
        </vs-button>
      </vs-col>
    </vs-row>
    <vs-row v-if="vazio || loading">
      <vs-col>
        <vs-alert style="text-align:center;padding: 0 5% 0 5%" color="success" active="true">
          <h1>Não existem documentos para analisar.</h1>
        </vs-alert>
      </vs-col>
    </vs-row>
    <vs-row>
      <vs-col vs-lg="8" vs-md="8" vs-sm="12" class="vx-col mb-10">
        <vx-card v-for="(arquivo, index) in arquivos" v-bind:key="arquivo.id" cardBorder noShadow>
          <vs-popup title="Motivo Reprovação" :active.sync="popupActivo">
            <ul v-if="motivosReprovacao" class="leftx mb-5">
              <li v-for="motivo in motivosReprovacao" v-bind:key="motivo.id">
                <vs-radio
                  v-model="motivoSelecionado"
                  :vs-name="motivo.motivo"
                  :vs-value="motivo.motivo"
                >{{motivo.motivo}}</vs-radio>
              </li>
            </ul>
            <vs-button
              @click="confirmarReprovar(arquivoRemover, motivoSelecionado)"
              color="success"
              type="filled"
            >Confirmar</vs-button>
            <vs-button
              class="ml-5"
              @click="popupActivo = false"
              color="danger"
              type="filled"
            >Cancelar</vs-button>
          </vs-popup>
          <vs-popup title="Aprovar" :active.sync="popUpAprovar">
            <h1 class="mb-5">Tem certeza?</h1>
            <vs-button
              @click="confirmarAprovar(arquivo, index)"
              color="success"
              type="filled"
            >Confirmar</vs-button>
            <vs-button
              class="ml-5"
              @click="popUpAprovar = false"
              color="danger"
              type="filled"
            >Cancelar</vs-button>
          </vs-popup>
          <vs-row class="mb-5">
            <vs-col vs-w="12">
              <h3>{{ arquivo.contrato_anexo.contrato_anexo_tipo.nome }}</h3>
            </vs-col>
          </vs-row>
          <vs-row>
            <vs-col vs-w="12">
              <a target="_blank" :href="`${arquivo.contrato_anexo.url}`">
                <img width="100%" height="100%" :src="`${arquivo.contrato_anexo.url}`" />
              </a>
            </vs-col>
            <vs-col style="margin-top:20px" vs-w="12">
              <vs-button
                @click="aprovarDocumento(arquivo, index)"
                color="success"
                type="relief"
                size="small"
                class="font-bold"
                style="margin-right:10px"
              >
                <feather-icon class="align-middle inline-block mr-2" icon="CheckIcon" />Aprovar
              </vs-button>
              <vs-button
                @click="reprovarDocumento(arquivo)"
                color="danger"
                type="relief"
                size="small"
                class="font-bold"
              >
                <feather-icon class="align-middle inline-block mr-2" icon="DeleteIcon" />Reprovar
              </vs-button>
            </vs-col>
          </vs-row>
        </vx-card>
      </vs-col>
      <vs-col vs-lg="4" vs-md="4" vs-sm="12" class="vx-col mb-10">
        <vx-card v-if="contrato && !vazio" title="Dados do contrato" cardBorder noShadow>
          <div class="vx-row">
            <vs-col vs-lg="12" vs-md="12" vs-sm="12" class="vx-col">
              <div class="vx-row">
                <vs-col vs-w="12" class="vx-col">
                  <span class="font-bold">Contrato:</span>
                  <div>{{contrato.id}}</div>
                </vs-col>
              </div>
              <div class="vx-row mt-5">
                <vs-col vs-w="12" class="vx-col">
                  <span class="font-bold">Código:</span>
                  <div>{{contrato.codigo}}</div>
                </vs-col>
              </div>
              <div v-if="cliente.beneficios" class="vx-row mt-5">
                <vs-col vs-w="12" class="vx-col">
                  <span class="font-bold">Benefício:</span>
                  <div>{{cliente.beneficios[0].beneficio}}</div>
                </vs-col>
              </div>
              <div v-if="cliente.beneficios" class="vx-row mt-5">
                <vs-col vs-w="12" class="vx-col">
                  <span class="font-bold">Valor Benefício:</span>
                  <div>
                    <money
                      style="
                      box-shadow: 0 0 0 0;
                      border: 0 none;
                      outline: 0;
                      font-size: 14px"
                      v-model.lazy="cliente.beneficios[0].valor"
                      :disabled="true"
                      v-bind="settings"
                    />
                  </div>
                </vs-col>
              </div>
              <div v-if="cliente.beneficios" class="vx-row mt-5">
                <vs-col vs-w="12" class="vx-col">
                  <span class="font-bold">Espécie:</span>
                  <div>{{cliente.beneficios[0].especie_beneficio.id}} - {{cliente.beneficios[0].especie_beneficio.descricao}}</div>
                </vs-col>
              </div>
              <div v-if="cliente.beneficios" class="vx-row mt-5">
                <vs-col vs-w="12" class="vx-col">
                  <span class="font-bold">Data Filiação:</span>
                  <div>{{cliente.beneficios[0].filiacao | formatarData}}</div>
                </vs-col>
              </div>
              <div class="vx-row mt-5">
                <vs-col vs-w="12" class="vx-col">
                  <span class="font-bold">Valor do desconto:</span>
                  <!-- <span>R$ {{contrato.valor}}</span> -->
                  <div>
                    <money
                      style="
                      box-shadow: 0 0 0 0;
                      border: 0 none;
                      outline: 0;
                      font-size: 14px"
                      v-model.lazy="contrato.valor"
                      :disabled="true"
                      v-bind="settings"
                    />
                  </div>
                </vs-col>
              </div>
            </vs-col>
          </div>
        </vx-card>
        <vx-card v-if="cliente && !vazio" title="Dados do cliente" cardBorder noShadow>
          <div class="vx-row">
            <vs-col vs-lg="12" vs-md="12" vs-sm="12" class="vx-col">
              <div class="vx-row">
                <vs-col vs-w="12" class="vx-col">
                  <span class="font-bold">Orgão expedidor:</span>
                  <div>{{cliente.orgao_expeditor}}</div>
                </vs-col>
              </div>
              <div class="vx-row mt-5">
                <vs-col vs-w="12" class="vx-col">
                  <span class="font-bold">Data nascimento:</span>
                  <div>{{cliente.data_nascimento | formatarData}}</div>
                </vs-col>
              </div>

              <div v-if="cliente.nome_mae" class="vx-row mt-5">
                <vs-col vs-w="12" class="vx-col">
                  <span class="font-bold">Nome mãe:</span>
                  <div>{{cliente.nome_mae}}</div>
                </vs-col>
              </div>
              <div v-if="cliente.nome_pai" class="vx-row mt-5">
                <vs-col vs-w="12" class="vx-col">
                  <span class="font-bold">Nome pai:</span>
                  <div>{{cliente.nome_pai}}</div>
                </vs-col>
              </div>
              <div class="mt-5" v-for="endereco in cliente.enderecos" v-bind:key="endereco.id">
                <div class="vx-row">
                  <vs-col vs-w="12" class="vx-col">
                    <span class="font-bold">Endereço:</span>
                    <div>{{endereco.endereco}} , {{endereco.bairro}}, {{endereco.numero}}, {{endereco.cidade.nome}}, {{endereco.cidade.estado.nome}}</div>
                  </vs-col>
                </div>
              </div>
            </vs-col>
          </div>
        </vx-card>
      </vs-col>
    </vs-row>
  </div>
</template>

<script>
import api from "@services/api-service";
import { Money } from "v-money";

export default {
  components: { Money },
  data() {
    return {
      loading: false,
      arquivos: [],
      cliente: {},
      contrato: {},
      vazio: false,
      contratoAnaliseId: null,
      popupActivo: false,
      popUpAprovar: false,
      motivosReprovacao: [],
      arquivoRemover: {},
      motivo: "",
      motivoSelecionado: "",
      aprovadoCount: 0,
      arquivosCount: 0,
      analisado: 0,
      settings: {
        decimal: ",",
        thousands: ".",
        prefix: "R$ ",
        suffix: "",
        precision: 2,
        masked: false
      }
    };
  },
  mounted() {
    this.$vs.loading();
  },
  created() {
    this.getContrato();
    this.analisado = 0;
  },
  watch: {
    motivo(motivo) {
      this.motivoSelecionado = motivo;
    },
    //Para atualizar quando todos os arquivos forem analisados
    analisado(analisado) {
      if (analisado === this.arquivosCount && this.contratoAnaliseId) {
        setTimeout(async () => {
          await api().post(
            `contratos/analise-documentos/alterar-status-analise`,
            {
              id: this.contratoAnaliseId
            }
          );

          this.getContrato();
        }, 1000);
      }
    }
  },
  methods: {
    voltarHome() {
      this.$router.push("/contratos");
    },
    aprovarDocumento() {
      this.popUpAprovar = true;
    },
    async confirmarAprovar(arquivo, index) {
      this.$vs.loading();
      let response = await api().post(`contratos-analise-documentos/aprovar`, {
        id: arquivo.id
      });

      if (response.data) {
        this.aprovadoCount++;
        this.analisado++;
        this.popUpAprovar = false;

        setTimeout(() => {
          this.arquivos.shift();
          this.$vs.loading.close();
        }, 1000);
      } else {
        this.$vs.loading.close();
      }
    },
    reprovarDocumento(arquivo) {
      this.$vs.loading();
      this.arquivoRemover = arquivo;
      this.getMotivosErro(arquivo);
      this.popupActivo = true;
    },
    async confirmarReprovar(arquivoRemover, motivoSelecionado) {
      this.$vs.loading();
      let response = await api().post(`contratos-analise-documentos/reprovar`, {
        id: arquivoRemover.id,
        erro: motivoSelecionado
      });

      if (response.data.status) {
        this.popupActivo = false;
        this.analisado++;

        setTimeout(() => {
          this.arquivos.shift();
          this.$vs.loading.close();
        }, 1200);
      } else {
        alert(response.data.erro);
        this.popupActivo = false;
        this.analisado++;
        setTimeout(() => {
          this.arquivos.shift();
        }, 700);
      }
    },
    async getMotivosErro(arquivo) {
      this.motivosReprovacao = [];
      let response = await this.$store.getters.fetchMotivosErro(
        arquivo.contrato_anexo_id
      );
      this.$vs.loading.close();
      if (response.data) {
        this.motivosReprovacao = response.data;
      }
    },
    limpaCampos() {
      this.analisado = 0;
      this.contratoAnaliseId = null;
      this.arquivos = [];
      this.cliente = [];
      this.contrato = [];
      this.arquivosCount = 0;
      this.aprovadoCount = 0;
    },
    async getContrato() {
      this.limpaCampos();
      let response = await this.$store.getters.fetchContratosAnalise();
      console.log(response.data);
      if (response.data) {
        this.vazio = false;
        this.arquivos = response.data.arquivos;
        this.contratoAnaliseId =
          response.data.arquivos[0].contrato_analise_documentacao_id;
        this.arquivosCount = this.arquivos.length;
        this.cliente = response.data.cliente;
        this.contrato = response.data.contrato;
        this.$vs.loading.close();
      } else {
        this.vazio = true;
        setTimeout(() => location.reload(), 5000);
        this.$vs.loading.close();
      }
    }
  }
};
</script>
